export const defaultPathList = [
  { label: 'Settings', isLink: false },
  { label: 'Advanced settings', isLink: false },
  { label: 'SMS configuration', isLink: false },
];

export const defaultSearch = {
  fuzzy: null,
  siteTag: null,
  site: null
};

export const searchType = {
  fuzzy: {
    value: 'fuzzy'
  },
  siteTag: {
    value: 'siteTag',
    label: '0678db4ca9'
  },
  site: {
    value: 'site',
    label: 'a7d6475ec8'
  }
};

export const tableColumn = [
  { label: '49ee308734', accessor: 'name', sortable: true },
  { label: 'de88250cdc', accessor: 'accessLevelLabel', sortable: true },
  { label: 'b8cb1a8790', accessor: 'twilioAccountSid', sortable: true },
  { label: 'd98c09f89f', accessor: 'twilioFromNumber', sortable: true },
  { label: '2841a38cbf', accessor: 'resendAfter', sortable: true },
  { label: 'c37d6da05a', accessor: 'maximumResend', sortable: true },
  { label: '3923abc37b', accessor: 'maximumRequest', sortable: true },
  { label: '7c3612e44a', accessor: 'denialPeriod', sortable: true },
  { label: 'ed74a86521', accessor: 'OtpExpiresIn', sortable: true },
  { label: '6bbce8f4aa', accessor: 'allowedPhonePrefix', sortable: true }
]

export const defaultSelectAllItem = { id: 0, title: 'b1c94ca2fb', isActive: false };

export const defaultModalStatus = {
  addOrEdit: {
    type: 'addOrEdit',
    status: false,
  },
  delete: {
    type: 'delete',
    status: false,
  },
};

export const smsConfigField = {
  name: 'name',
  twilioAccountSid: 'twilioAccountSid',
  twilioAuthToken: 'twilioAuthToken',
  twilioFromNumber: 'twilioFromNumber',
  resendAfter: 'resendAfter',
  maximumResend: 'maximumResend',
  maximumRequest: 'maximumRequest',
  denialPeriod: 'denialPeriod',
  otpExpiresIn: 'otpExpiresIn',
  allowedPhonePrefix: 'allowedPhonePrefix',
  accessLevel: 'accessLevel',
  siteTagOrSite: 'siteTagOrSite'
};

export const defaultSmsConfigState = {
  [smsConfigField['name']]: {
    value: '',
    required: true,
    minLength: 1,
    maxLength: 64,
    dirty: false,
    valid: false
  },
  [smsConfigField['twilioAccountSid']]: {
    apiKey: 'name',
    value: '',
    required: true,
    minLength: 1,
    maxLength: 64,
    dirty: false,
    valid: false
  },
  [smsConfigField['twilioAuthToken']]: {
    value: '',
    required: true,
    minLength: 1,
    maxLength: 128,
    dirty: false,
    valid: false
  },
  [smsConfigField['twilioFromNumber']]: {
    value: '',
    required: true,
    regex: /^\+\d{1,63}$/,
    dirty: false,
    valid: false
  },
  [smsConfigField['resendAfter']]: {
    value: 2, // default
    required: true,
    min: 0,
    max: 60,
    dirty: false,
    valid: false
  },
  [smsConfigField['maximumResend']]: {
    value: 3, // default
    required: true,
    min: 0,
    max: 60,
    dirty: false,
    valid: false
  },
  [smsConfigField['maximumRequest']]: {
    value: 3, // default
    required: true,
    min: 0,
    max: 60,
    dirty: false,
    valid: false
  },
  [smsConfigField['denialPeriod']]: {
    value: 120, // default
    required: true,
    min: 0,
    max: 1440,
    dirty: false,
    valid: false
  },
  [smsConfigField['otpExpiresIn']]: {
    value: 10, // default
    required: true,
    min: 5,
    max: 30,
    dirty: false,
    valid: false
  },
  [smsConfigField['allowedPhonePrefix']]: {
    value: '*',
    required: true,
    regex: /^(\*|\+?\d+(\,\+?\d+)*)$/,
    dirty: false,
    valid: false
  },
  [smsConfigField['accessLevel']]: {
    value: null
  },
  [smsConfigField['siteTagOrSite']]: {
    value: null
  }
};